import spring from './spring';

export default function ensureSpring(styles) {
  return Object.keys(styles).reduce(function (acc, key) {
    var value = styles[key];
    acc[key] = typeof value === 'number' ? spring(value) : value;
    return acc;
  }, {});
}


//////////////////
// WEBPACK FOOTER
// ./~/react-router-transition/es/ensureSpring.js
// module id = 374
// module chunks = 4